import React, { Fragment, useState, useEffect } from "react";
import { useEffectOnce } from "../../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import {
  setProcessing,
  loadPage,
  setPageValue,
  setPanes,
  deleteEntity,
  entityDeleted,
  disposePage,
  importDatasetId,
  pauseSchedule,
  resumeSchedule,
} from "../../../redux/slices/schedulelocatorpageslice";
import { addNotification } from "../../../redux/slices/notificationsslice";
import {
  hideAppDialog,
  setAppDialog,
} from "../../../redux/slices/appdialogslice";
import { apiErrorsHandler, getErrorMessages } from "../../../api/httpclient";
import { useNavigate, NavLink } from "react-router-dom";
import { Splitter } from "@progress/kendo-react-layout";
import { Page } from "../../page";
import { Loader } from "@progress/kendo-react-indicators";
import { Input } from "@progress/kendo-react-inputs";
import { notificationDurationMiddle } from "../../../lib/utils";
import { ReactComponent as ImportIcon } from "../../../icons/import.svg";

import "./schedulelocatorpage.css";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import {
  ScheduleExportsViewer,
  ScheduleImportsViewer,
  ScheduleViewer,
} from "../../../components/scheduleviewer";

export const ScheduleLocatorPage = (props) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.scheduleLocatorPage);
  const appearance = useSelector((state) => state.appearance);
  const filter = pageState.filter;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [handleAnimation, setHandleAnimation] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (handleAnimation) setHandleAnimation(false);
    }, 1500);
  });

  const schedule = pageState.items;

  useEffect(() => {
    if (!schedule || schedule.length === 0) {
      Cookies.set("noschedule", "true", { expires: 1 });
    } else {
      Cookies.remove("noschedule");
    }
  }, [schedule]);

  /*initial page load*/
  useEffectOnce(() => {
    dispatch(loadPage(currentUser, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("datasets.locator.loading_errormessage"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("datasets.locator.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          navigate("/", { replace: true });
        };

        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );

    return () => {
      dispatch(disposePage(true));
    };
  }, []);
  /*initial load*/

  /*splitter*/
  const handleOnSplitterChange = (e) => {
    dispatch(setPanes(e.newState));
  };
  /*splitter*/

  const handleOnDelete = (e, item) => {
    dispatch(
      setAppDialog({
        isVisible: true,
        className: "schedulelocator-page-are-you-sure",
        title: t("datasets.datasetview.warning"),
        content: t("schedule.deletequestion"),
        actions: {
          yesButton: {
            title: t("datasets.locator.yes"),
            handler: () => {
              dispatch(hideAppDialog());

              dispatch(deleteEntity(item.Id, item.importexport, t)).then(
                (response) => {
                  dispatch(
                    addNotification({
                      text: t("schedule.deletesuccess"),
                      type: "success",
                      closable: true,
                      duration: notificationDurationMiddle,
                      position: "topRight",
                    }),
                  );
                },
                (err) => {
                  dispatch(setProcessing({ processing: false }));

                  const handleResponseReceived = (
                    state,
                    dispatch,
                    navigate,
                    payload,
                  ) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                      errorMessages = [t("datasets.locator.unknown_error")];
                    else {
                      errorMessages = getErrorMessages(errorMessages, 1);

                      if (payload.data.ErrorCodes.EntityDoesNotExist)
                        dispatch(entityDeleted(item.Id));
                    }

                    dispatch(
                      addNotification({
                        text: errorMessages[0],
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      }),
                    );
                  };

                  const handleUnhandled = (
                    state,
                    dispatch,
                    navigate,
                    payload,
                  ) => {
                    let errorMessage = t("datasets.locator.unknown_error");
                    dispatch(
                      addNotification({
                        text: errorMessage,
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      }),
                    );
                  };

                  apiErrorsHandler({}, dispatch, navigate, err, null, {
                    responseReceived: handleResponseReceived,
                    unhandled: handleUnhandled,
                  });
                },
              );
            },
          },
          noButton: { title: t("datasets.locator.no") },
        },
      }),
    );
  };

  const handlePauseSchedule = (e, item) => {
    debugger;
    dispatch(pauseSchedule(item.Id, item.importexport, t)).then(
      (response) => {
        if (item.importexport == "export") {
          const updatedItems = pageState.exports.map((schedule) =>
            schedule.Id === item.Id
              ? { ...schedule, IsActive: false }
              : schedule,
          );

          dispatch(setPageValue({ id: "exports", value: updatedItems }));
        }

          if (item.importexport == "import") {
          const updatedItems = pageState.imports.map((schedule) =>
            schedule.Id === item.Id
              ? { ...schedule, IsActive: false }
              : schedule,
          );

          dispatch(setPageValue({ id: "imports", value: updatedItems }));
        }
      },
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("datasets.locator.loading_errormessage"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("datasets.locator.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          navigate("/", { replace: true });
        };

        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const handleResumeSchedule = (e, item) => {
    debugger;
    dispatch(resumeSchedule(item.Id, item.importexport, t)).then(
      (response) => {
        if (item.importexport == "export") {
          const updatedItems = pageState.exports.map((schedule) =>
            schedule.Id === item.Id
              ? { ...schedule, IsActive: true }
              : schedule,
          );

          dispatch(setPageValue({ id: "exports", value: updatedItems }));
        }

        if (item.importexport == "import") {
          const updatedItems = pageState.imports.map((schedule) =>
            schedule.Id === item.Id
              ? { ...schedule, IsActive: true }
              : schedule,
          );

          dispatch(setPageValue({ id: "imports", value: updatedItems }));
        }
      },
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("datasets.locator.loading_errormessage"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("datasets.locator.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          navigate("/", { replace: true });
        };

        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const handleOnImport = (id, from) => {
    if (from !== "fromfile") {
      dispatch(importDatasetId(id, t));
    } else {
      navigate(`/importdataset?datasetid=${id}&from=file`, { replace: true });
    }
  };

  return (
    <Fragment>
      <Page
        id="scheduleLocatorPage"
        className="schedulelocator-page"
        title={t("schedule.scheduleview")}
        animation={props.animation}
      >
        <Fragment>
          {pageState.processing && (
            <div className="page-loader">
              <Loader
                size={"large"}
                type="infinite-spinner"
                themeColor={"primary"}
              />
              {pageState.processingText && (
                <div style={{ fontSize: 13, color: currentTheme.primary }}>
                  {pageState.processingText}
                </div>
              )}
            </div>
          )}
          {pageState.pageLoaded && (
            <Fragment>
              <div className="schedulelocator-desktop-view">
                <Splitter
                  style={{ border: "none" }}
                  panes={pageState.panes}
                  onChange={handleOnSplitterChange}
                >
                  <div className="schedulelocator-page-manager">
                {pageState.canCreate && (
                  <div className="new-dataset">
                    <NavLink to="/createschedule">
                      <div className="new-container" style={{}}>
                        <div>
                          <div className="k-icon k-i-plus"></div>
                          <div>{t("schedule.newSchedule")}</div>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to="/importschedule">
                      <div className="new-container" style={{}}>
                        <div>
                          <ImportIcon width={15} />
                          <div>{t("schedule.importSchedule")}</div>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                )}
                <div className="filter-dataset">
                  <div
                    style={{
                      marginTop: 4,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Input
                      onChange={(e) => {
                        setHandleAnimation(true);
                        dispatch(
                          setPageValue({ id: "filter", value: e.value }),
                        );
                        // handleOnFilter(e.value);
                      }}
                      value={filter}
                      type="search"
                      autoFocus={true}
                      style={{ flex: 1, padding: 8 }}
                      placeholder={t("datasets.locator.search")}
                    />
                  </div>
                </div>
                  </div>
                  <div className={`right ${handleAnimation ? "fade" : null}`}>
                    <div className="dataset-locator-wrapper">
                      <div className="title">{t("schedule.scheduleview")}</div>
                      <ScheduleExportsViewer
                        canView={pageState.canView}
                        canCreate={pageState.canCreate}
                        canEdit={pageState.canEdit}
                        canDelete={pageState.canDelete}
                        onDelete={handleOnDelete}
                        handlePauseSchedule={handlePauseSchedule}
                        handleResumeSchedule={handleResumeSchedule}
                      />

                      <ScheduleImportsViewer
                        canView={pageState.canView}
                        canCreate={pageState.canCreate}
                        canEdit={pageState.canEdit}
                        canDelete={pageState.canDelete}
                        onDelete={handleOnDelete}
                        handlePauseSchedule={handlePauseSchedule}
                        handleResumeSchedule={handleResumeSchedule}
                      />
                    </div>
                  </div>
                </Splitter>
              </div>
              <div className="schedulelocator-mobile-view">
                <div className="schedulelocator-mobile-heading">
                  <h1>{t("schedule.scheduleview")}</h1>
                </div>
                <Input
                  onChange={(e) =>
                    dispatch(setPageValue({ id: "filter", value: e.value }))
                  }
                  value={filter}
                  type="search"
                  placeholder={t("datasets.locator.search")}
                  className="schedulelocator-mobile-search"
                />
                <div className="schedulelocator-mobile-list">
                  <ScheduleExportsViewer
                    canView={pageState.canView}
                    canCreate={pageState.canCreate}
                    canEdit={pageState.canEdit}
                    canDelete={pageState.canDelete}
                    onDelete={handleOnDelete}
                    handlePauseSchedule={handlePauseSchedule}
                    handleResumeSchedule={handleResumeSchedule}
                  />
                  <ScheduleImportsViewer
                    canView={pageState.canView}
                    canCreate={pageState.canCreate}
                    canEdit={pageState.canEdit}
                    canDelete={pageState.canDelete}
                    onDelete={handleOnDelete}
                    handlePauseSchedule={handlePauseSchedule}
                    handleResumeSchedule={handleResumeSchedule}
                  />
                </div>
              </div>
            </Fragment>
          )}
        </Fragment>
      </Page>
      <style>
        {`
                    /*page class*/
                    .schedulelocator-page
                    {
                        background-color: transparent;
                        padding: ${currentTheme.pagePadding}; 
                    }

                    .schedulelocator-wrapper{ 
                        direction:${
                          appearance.isRightToLeft ? "rtl" : "ltr"
                        }                      
                    }    
                    .schedulelocator-page .k-splitter{
                      flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }
                      
                    .schedulelocator-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                    .schedulelocator-page .k-splitbar.k-splitbar-horizontal
                    {
                        background-color: ${currentTheme.paneSeparatorBg};
                    }

                    .schedulelocator-page .k-splitbar
                    {
                        width: ${currentTheme.paneSeparatorWidth};
                    }

                   
                    /*are you sure to delete*/
                    .schedulelocator-page-are-you-sure .k-widget
                    {
                      /*width of the dialog*/
                      width: 300px;
                    }    
                    
                    .schedulelocator-page-are-you-sure .k-widget .k-dialog-titlebar.k-header.k-header
                    {
                        /*bg color of the header*/
                        background-color: ${currentTheme.primary};
                    }


                    /*the manager*/
                    .schedulelocator-page > .content .schedulelocator-page-manager
                    {
                        display: flex;
                        flex-direction: column;
                        flex-wrap: nowrap;
                        height: 100%;
                        overflow: hidden;/* auto;*/
                        padding: 0 0 8px 0;
                        border: ${currentTheme.managerBorder};
                        border-radius: ${currentTheme.pageBorderRadius};
                        background-color: ${currentTheme.componentBgFaded};
                    }

                    .schedulelocator-page > .content .schedulelocator-page-manager .k-dropdownlist:focus,
                    .schedulelocator-page > .content .schedulelocator-page-manager .k-input:focus
                    {
                        box-shadow: none;
                    }

                    .schedulelocator-page > .content .schedulelocator-page-manager .k-dropdownlist,
                    .schedulelocator-page > .content .schedulelocator-page-manager .k-input
                    {
                        background-color: transparent;
                        color: ${currentTheme.componentText};
                    }


                    /*new dataset*/
                    .schedulelocator-page .new-dataset 
                    {
                        display: flex;
                        flex-direction:column;
                        justify-content: center;
                        align-items: center;
                        padding: 32px 16px;

                    }

                    .schedulelocator-page .new-dataset a
                    {
                        width: 100%;
                        display: inline-block;
                        color: ${currentTheme.componentText};
                        text-decoration: none;
                        margin-bottom:15px;
                    }

                    .schedulelocator-page .new-dataset .new-container
                    {
                        padding: 16px 16px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid ${currentTheme.separatorColor};
                        border-radius: 8px;
                        color: ${currentTheme.componentText};   
                        opacity: 0.5;
                    }
                    
                    .schedulelocator-page .new-dataset .new-container:hover
                    {
                        cursor: pointer;
                        background-color: ${currentTheme.componentBgFaded};
                        border-color: ${currentTheme.separatorColor};
                        opacity: 1;
                        transition: opacity 1000ms;
                    }

                    .schedulelocator-page .new-dataset .new-container > div
                    {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }                    

                    .schedulelocator-page .new-dataset .new-container .k-icon
                    {
                        color: ${currentTheme.componentText};   
                        font-size: 20px;
                        font-weight: 300;
                        margin-right: 4px;
                    }    
                    
                    .schedulelocator-page .new-dataset .new-container svg
                    {
                        color: ${currentTheme.componentText};   
                        margin-right: ${appearance.isRightToLeft ? "0" : "4px"};
                        margin-left: ${appearance.isRightToLeft ? "4px" : "0"};
                    }                                   

                    .schedulelocator-page .filter-dataset
                    {
                        display: flex;
                        flex-direction: column;
                        margin-top: 0px;
                        padding: 32px 16px;
                        border-top: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                    }

                    .schedulelocator-page .filter-dataset .k-input::placeholder
                    {
                        color: ${currentTheme.componentText};
                        font-style: italic;
                    }

                    .schedulelocator-page .filter-dataset .k-button
                    {
                        background-color: transparent;
                        border-color: ${currentTheme.separatorColor};
                        border-radius: 50%;
                    }

                    .schedulelocator-page .filter-dataset .k-button .k-icon
                    {
                        color: ${currentTheme.componentText};
                    }

                    .schedulelocator-page .filter-dataset .k-button:hover
                    {
                        background-color: ${currentTheme.separatorColor};
                    }

                    .schedulelocator-page .fav-dataset
                    {
                        display: flex;
                        flex-direction: column;
                        padding: 32px 16px 16px 16px;
                        height: 100%;
                        overflow-y: hidden;
                        border-top: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                    }

                    .schedulelocator-page .fav-dataset .title
                    {
                        color: ${currentTheme.componentText};
                        font-weight: 400;
                        font-size: 16px;
                        margin-bottom: 6px;
                        margin-top: 0px;
                        padding-bottom: 6px;
                        border-bottom: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                    }

                    /*fav list*/
                    .schedulelocator-page .fav-dataset .list-container
                    {
                        /*border: 1px dashed ${currentTheme.separatorColor};*/
                        border-radius: 6px;
                        padding: 0;
                        overflow-y: auto;
                    }

                    .schedulelocator-page .fav-dataset .list-root
                    {
                        border-spacing: 0 6px;/*vertical space between 2 rows*/
                    }

                    .schedulelocator-page .fav-dataset .list-root .list-item
                    {
                    }

                    .schedulelocator-page .fav-dataset .fav-schedule .list-item .list-item-img
                    {
                        
                    }
                    .schedulelocator-page .fav-dataset .fav-schedule .list-item .list-item-img img
                    {
                        width: 40px;
                        height: auto;
                        aspect-ratio: 4 / 3;
                        border-radius: 6px;
                    }

                    .schedulelocator-page .fav-dataset .fav-schedule .list-item .list-item-title
                    {
                        width: 100%;
                        vertical-align: middle;/*fine tuning*/
                    }
                    
                    .schedulelocator-page .fav-dataset .list-root .list-item-view-dataset a,
                    .schedulelocator-page .fav-dataset .list-root .list-item-edit-dataset a                    
                    {                
                        padding: 4px;
                        /*border: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                        border-radius: 4px;*/
                        border: none;
                        display: flex;
                        align-items: center;
                        color: ${currentTheme.touchColor}!important;
                        text-decoration: none;
                    } 

                    .schedulelocator-page .fav-dataset .list-root .list-item-remove            
                    {                                       
                        color: ${currentTheme.error}!important;
                    } 

                    .schedulelocator-page .fav-dataset .fav-schedule .list-item-remove:hover
                    {
                        color: ${currentTheme.touchColor};
                        cursor: pointer;
                    }

                    .schedulelocator-page .right                    
                    {
                        background-color: transparent;
                        height: 100%;
                        padding-left: 0px;
                        border: ${currentTheme.pageFormBorder};   
                        border-radius: ${currentTheme.pageBorderRadius};
                        display: flex;
                        flex-direction: column;
                    }                    

                    .schedulelocator-page .right.fade
                    {
                        animation-name: hide-dataset;
                        animation-duration: 2s;
                    }

                    @keyframes hide-dataset {
                        0%   {opacity:0};}
                    }

                    .schedulelocator-page .dataset-locator-wrapper{
                    }

                    .schedulelocator-page .dataset-locator-wrapper .title
                    {
                        font-size: 17px;
                        font-weight: 700;
                        color: ${currentTheme.touchColor};
                        padding: 6px 16px 6px 16px;
                        font-style: italic;
                        border-bottom: ${currentTheme.pageFormBorder};
                    }

                    .schedulelocator-desktop-view {
                      flex: 0 0 100%;
                      width: 100%;
                      min-width: 0;
                      height: 100%;
                    }

                    .schedulelocator-desktop-view .k-splitter {
                      width: 100%;
                      height: 100%;
                    }

                    .schedulelocator-mobile-view {
                      display: none;
                    }

                    @media (max-width: 1024px) {
                      .schedulelocator-page > .content {
                        overflow-y: auto;
                      }

                      .schedulelocator-desktop-view {
                        display: none;
                      }

                      .schedulelocator-page .new-dataset {
                        display: none;
                      }

                      .schedulelocator-mobile-view {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        min-height: 100%;
                        padding: 18px 16px calc(80px + env(safe-area-inset-bottom));
                        box-sizing: border-box;
                        background: ${currentTheme.componentBg};
                        color: ${currentTheme.componentText};
                        direction: ${appearance.isRightToLeft ? "rtl" : "ltr"};
                      }

                      .schedulelocator-mobile-heading h1 {
                        margin: 0 0 18px;
                        color: ${currentTheme.componentText};
                        font-size: 21px;
                        font-weight: 600;
                      }

                      .schedulelocator-page .schedulelocator-mobile-search {
                        margin-bottom: 12px;
                        background: transparent;
                      }

                      .schedulelocator-mobile-list {
                        width: 100%;
                        min-width: 0;
                      }
                    }

                    `}
      </style>
    </Fragment>
  );
};
